import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import classnames from 'classnames'
import { SectionColumn } from 'pages/conversations/pages/search/pages/profile/ui/SectionColumn/SectionColumn'
import type { SectionConversationStore } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation'
import {
  ProviderSectionConversation,
  useSectionConversationContext,
} from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation/context/sectionConversationContext'
import { ConversationList } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation/ui/ConversationList/ui/ConversationList'
import { ConversationFilters } from 'pages/conversations/pages/search/pages/profile/ui/SectionConversation/ui/ConversationFilters/ConversationFilters'
import { Header } from './Header/Header'
import styles from './styles.module.scss'

const SectionConversationContent = observer(() => {
  const store = useSectionConversationContext()

  return (
    <>
      <SectionColumn
        className={styles.wrap}
        classNameContent={classnames(styles.content, {
          [styles.hideFilter]: store.hideFilter,
        })}
        renderHeader={<Header />}
      >
        <ConversationFilters />
        <ConversationList />
      </SectionColumn>
    </>
  )
})

type ISectionConversationProps = {
  store: SectionConversationStore
}

export const SectionConversation: FC<ISectionConversationProps> = observer(({ store }) => {
  return (
    <ProviderSectionConversation value={store}>
      <SectionConversationContent />
    </ProviderSectionConversation>
  )
})
